import { render, staticRenderFns } from "./GithubWorkspaceModal.vue?vue&type=template&id=412ec522&"
import script from "./GithubWorkspaceModal.vue?vue&type=script&lang=js&"
export * from "./GithubWorkspaceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GithubWorkspaceModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GithubWorkspaceModal.vue
// module id = 2272
// module chunks = 1